import { ReactNode } from 'react';
import { ClassName } from '@/interfaces';

interface Props extends ClassName {
	children: ReactNode;
}

export const GenericCard: React.FC<Props> = ({ className, children }) => {
	return (
		<div
			className={`h-auto min-h-screen md:min-h-0 md:h-[95%] bg-white rounded-2xl p-4 ${className}`}
		>
			{children}
		</div>
	);
};
